__turbopack_context__.v({
  "figure": "p5_gjG_figure",
  "gallery": "p5_gjG_gallery",
  "galleryContent": "p5_gjG_galleryContent",
  "image": "p5_gjG_image",
});
